import React, { useRef, useEffect } from "react";
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useSelector } from "react-redux";
import { constant } from "../../../../utils/constant";

const ViewPicture = ({
  showModal,
  closeModal,
  selectedItem,
  getLangTranslation = () => {},
}) => {
  const { ID: parentID } = useSelector(({ auth }) => auth.user);

  const modalRef = useRef();

  useEffect(() => {
    if (showModal) {
      const modal = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
      modal.show();
    }
  }, [showModal]);

  const isImage = constant.IMAGE_EXTENSION.some((ext) =>
    selectedItem?.video?.endsWith(ext.toLowerCase())
  );

  return (
    <div
      className="modal fade"
      tabIndex="-1"
      ref={modalRef}
      aria-hidden={!showModal}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div
          className="modal-content"
          style={{ width: "55%", marginLeft: "15rem" }}
        >
          <div className="modal-header border-0 pb-0">
            <h6 className="modal-title text-blue-900">
              {getLangTranslation("PICTURE", "Picture")}
            </h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body">
            <div className="text-center">
              {/* {!isImage ? (
                <img
                  className="rounded-3 pt-cursor"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    display: "block",
                    margin: "auto",
                  }}
                  src={selectedItem?.thumbnail}
                  alt="Screenshot"
                />
              ) : (
                showModal && (
                  <video
                    style={{
                      maxWidth: "100%",
                      maxHeight: "75vh",
                      display: "block",
                      margin: "auto",
                    }}
                    controls
                  >
                    <source
                      src={selectedItem?.video}
                      // type="video/mp4"
                    />
                    <source
                      src={selectedItem?.thumbnail}
                      // type="video/ogg"
                    />
                  </video>
                )
              )} */}
              <img
                className="rounded-3 pt-cursor"
                style={{ maxWidth: "100%", height: "auto", display: "block", margin: "auto"}}
                src={selectedItem}
                alt="Screenshot"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPicture;
